export const TIMEZONE_OPTIONS = [
    "Europe/Berlin", "Europe/Paris", "Europe/London", "Europe/Dublin",
    "Canada/Eastern", "Canada/Central", "Canada/Mountain", "Canada/Pacific",
    "US/Eastern", "US/Central", "US/Mountain", "US/Pacific", "UTC",
];
export const IMAGE_MAP = {
    // Ads Network Images
    klaviyo_private_key: "/assets/klaviyo_steps.png",
    // Shopify Instruction Images
    shopify_create_app: "/assets/shopify_create_app.png",
    shopify_app_name: "/assets/shopify_app_name.png",
    shopify_versions: "/assets/shopify_versions.png",
    shopify_details: "/assets/shopify_details.png",
    shopify_navigate: "/assets/shopify_navigate.png",
    // Affiliate Network Images
    avantlink_select_report: "/assets/avantlinkinstruction1.png",
    avantlink_subscription: "/assets/avantlinkinstruction2.png",
    awin_portal: "/assets/awininstruction1.png",
    awin_api_credentials: "/assets/awininstruction2.png",
    awin_portal2: "/assets/awininstruction3.png",
    cj_add_account: "/assets/cjinstruction1.png",
    cj_portal: "/assets/cjinstructionnew.png",
    cj_manage_by_status: "/assets/cjinstruction2.png",
    cj_all_program_terms: "/assets/cjinstruction3.png",
    cj_csv_format: "/assets/cjinstruction4.png",
    cj_csv_file: "/assets/cjinstruction5.png",
    impact_program_id: "/assets/impactinstruction1.png",
    impact_settings_api: "/assets/impactinstruction2.png",
    impact_create_access_token: "/assets/impactinstruction3.png",
    impact_overview: "/assets/impactinstruction4.png",
    impact_contact_information: "/assets/impactinstruction5.png",
    impact_api_scope: "/assets/impactinstruction6.png",
    impact_navigate_app: "/assets/impactinstruction7.png",
    impact_api_credentials: "/assets/impactinstruction8.png",
    levanta_portal: "/assets/levantainstruction1.png",
    rakuten_build_report: "/assets/rakuteninstruction1.png",
    rakuten_get_api: "/assets/rakuteninstruction2.png",
    rakuten_portal: "/assets/rakuteninstruction3.png",
    pepperjam_portal: "/assets/pepperjaminstruction1.png",
    refersion_portal: "/assets/refresioninstruction1.png",
    commissionfactory_portal: "/assets/commissionfactoryinstruction1.png",
    commissionfactory_profile: "/assets/commissionfactoryinstruction2.png",
    commissionfactory_api: "/assets/commissionfactoryinstruction3.png",
    partnerize_portal: "/assets/partnerizeinstruction1.png",
    partnerize_api: "/assets/partnerizeinstruction2.png",
    partnerize_adviser_id: "/assets/partnerizeinstruction3.png",
    partnerize_campaign_id: "/assets/partnerizeinstruction4.png",
    partnerize_copy_campaign: "/assets/partnerizeinstruction5.png",
    partnerize_partners: "/assets/partnerizeinstruction6.png",
};
export const FILE_MAP = {
    cj_csv_template: { url: "/assets/publisher-list-template.xlsx", name: "publisher-list-template.xlsx" },
};
